import React, { useEffect, useState } from 'react';
import FormioProvider from '../../../providers/FormioProvider';
import { Form } from '@formio/react';
import { properties, varOverriders, msg, btnsGuardar, btnsCancelar, formatosFecha } from './FormNuevaSolicitudData';
import Validations from '../../../AppValidation';
import RestProvider from 'providers/RestProvider';
import { loadState, saveState } from './../../../providers/localStorage';
import { localStorageName } from './../../../providers/localStorageData';
import { useHistory } from "react-router-dom";
import useOperations from '../generadorPdf/GeneradorPdfFunction';
import usePrecargas from '../Precargas/PrecargasFunction';
import FormioFunctions from '../Precargas/FormIoFunctions';
import FormPruebaStyle from './FormNuevaSolicitudStyle.css';
import ictFunctions from '../Precargas/ICTFunctions';
import validacionesFormIoFunctions from '../validacionesFormIO/validacionesFormioFunctions';
import { getUrl } from 'config/Config';
import Confirmacion from 'components/commons/Confirmacion/Confirmacion';
import { getContextFromUrl } from 'config/Config';
import SICAFunctions from '../Precargas/SICAFunctions';
import CompAutoFunctions from '../Precargas/CompAutoFunctions';
import { useSelector, useDispatch } from 'react-redux';
import { insertNewState, updatePropertyOfState } from 'redux/slicers/kingdomOV3Slice';


function FormNuevaSolicitud(props) {
    const { validation } = Validations();
    const { formioOperation } = FormioProvider();
    const { crudOperation, crudOperationsType } = RestProvider();
    const [formData, setFormData] = useState();
    const [submissionData, setSubmissionData] = useState();
    const history = useHistory();
    const [avanzarPagina, setAvanzarPagina] = useState(false);
    const [formularioCorrecto, setFormularioCorrecto] = useState(false);
    const [pdfAgenerar, setPdfAgenerar] = useState(false);
    const {functionValidacionID,functionValidadorRegex,functionValidacionIBAN, functionCamposEspecificos} = validacionesFormIoFunctions();
    const { getProvincias, getProvinciasDescripcion, getMunicipios, getTipoVias, getPaises, getOrganismos, calculaActuaEnCalidadDe,
            obtenerValoresUsuario, obtenerConvocatoria, obtenerPerfilSeleccionado, obtenerOrganismo, obtenerModBajaRADA } = FormioFunctions();
    const { getValorICT} = ictFunctions();
    const { getDatosRepresentanteSica } = SICAFunctions();
    const { getSolicitantesPuntosHistorico } = CompAutoFunctions();

    const { generarPDF } = useOperations(props);
    const  { obtenerInformacionBoja, obtenerDestinatariosExpedientes, obtenerUrlEndPoint } = usePrecargas();
 
    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const solicitudColaborativa = useSelector((state) => state.kingdomOV3.solicitudColaborativa);
    const perfilSeleccionado = useSelector((state) => state.kingdomOV3.perfilSeleccionado);
    const resourceFormNuevaSolicitud = useSelector((state) => state.kingdomOV3.resourceFormNuevaSolicitud);
    const solicitudActual = useSelector((state) => state.kingdomOV3.solicitudActual);
    const idExpTrewa = useSelector((state) => state.kingdomOV3.idExpTrewa);
    const fase = useSelector((state) => state.kingdomOV3.fase);
    const faseEstadoExpediente = useSelector((state) => state.kingdomOV3.faseEstadoExpediente);
    const idFase = useSelector((state) => state.kingdomOV3.idFase);
    const idEstadoFase = useSelector((state) => state.kingdomOV3.idEstadoFase);

    const dispatch = useDispatch();

    const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
    const [popUpTitle, setPopUpTitle] = useState("Título")
    const [popUpMesagge, setPopUpMesagge] = useState("Mensaje")
    const [popUpImage, setPopUpImage] = useState('exclamation-triangle-solid.svg')
    const showPopup = (title, mesagge, image) => { 
        setPopUpTitle(title)
        setPopUpMesagge(mesagge)
        setPopUpImage(image)
        setMostrarConfirmacion(true) 
    }

    /**
    * @function obtenerProcedenciaConvocatoria Obtiene la procedencia de una convocatoria (PCT2 o PCT3)
    */
    const obtenerProcedenciaConvocatoria = () => {
        return (procedimientoActual.fromPct3 !== undefined && procedimientoActual.fromPct3 === true) ? 'PCT3' : 'PCT2';
    }

    //Código de aplicación del procedimiento seleccionado
    const codigoAplicacion = procedimientoActual.codigoAplicacion;

    /**
     * @constant isConvocatoriaColaborativa 
     * Evaluando si la convocatoria es colaborativa
     */
    const convActual = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const isConvocatoriaColaborativa = convActual ?  convActual.colaborativa : false ;

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        if (props.handleLoading !== undefined) {
            props.handleLoading(true);
        }
        await obtenerPdfAgenerar();
        let submission = await getSubmissionData();
        let form = await getForm();
        await precargaDatos(submission, form);
    }

    //Efecto aplicado para obtener el formulario PDF cuando se realice el guardado del formulario
    useEffect(() => {
        if (formularioCorrecto) {
            obtenerFormularioPdf();
        }
    }, [formularioCorrecto]);

    //Efecto aplicado para avanzar al paso de Aporte de documentación cuando se realice la generación del formulario PDF
    useEffect(() => {
        if (avanzarPagina) {
            if((solicitudActual.revisarPresentacion || solicitudActual.revisarSubsanacion || solicitudActual.revisarAlegacion) && (perfilSeleccionado.descripcion === 'REPRESENTANTE_SICA' && !convocatoriaSeleccionada.repreAnexos)){
                props.handleProcessing(false);
                document.querySelector('body').style.overflow = 'auto';
                history.push('/FirmaSolicitud');
            }else{
                props.handleProcessing(false);
                history.push('/AporteDocumentacion');
            }
        }
    }, [avanzarPagina]);

    // Efecto aplicado para obtener los motivos de subsanación cuando se haya obtenido el id de la solicitud actual y los datos del formulario
    useEffect(() => {
        if (solicitudActual.id !== undefined && formData !== undefined) {
            getMotivosSubsanacion();
        }
    }, [formData, solicitudActual]);

    const calcularDataSource = (codApp) => {
        let dataSource = null;

        codApp === properties.codigoAplicacionF2 && (dataSource = properties.F2);
        codApp === properties.codigoAplicacionSUB && (dataSource = properties.SUB);

        return dataSource;
    }

    const getForm = async () => {
        let respuesta;
        
        await formioOperation(resourceFormNuevaSolicitud, {}, false).then(response => {
            respuesta = response;
            setFormData(response.data);
            if (props.handleLoading !== undefined) {
                props.handleLoading(false);
            }
        }).catch((error) => {
            if (props.handleLoading !== undefined) {
                props.handleLoading(false);
            }
        });
        return respuesta;
    }

    const getMotivosSubsanacion = async () => {
        if (fase === "SUBSA_BASE") {
            let camposNoSubsanables = null;
            await crudOperation(crudOperationsType.CUSTOM, 'motivoSubsanacionConvocatoria', {url: `/findAllSubsanablesByIdExpediente/${solicitudActual.id}`, method: 'get'}).then(response => {
                camposNoSubsanables = response.data;
            }).catch((error) => {
                if (props.handleLoading !== undefined) {
                    props.handleLoading(false);
                }
            });
            if (camposNoSubsanables !== null) {
                let arrayKeyNoSubsanables = camposNoSubsanables.map(msc => msc.idCampoFormulario)
                ocultarComponentesNoSubsanables(formData, arrayKeyNoSubsanables);
            }
        } 
    }

    const getSubmissionData = async () => {
        let respuesta;
        props.handleLoading(true);
        let idPro = procedimientoActual.id;
        let idSol = solicitudActual ? solicitudActual.idMoaddSolicitudPdf : null;

        if(procedimientoActual.fromPct3){

            let infoBoja = {};
            let idExpediente = null;
            let idFaseIdEstado = null;

            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_EXPEDIENTE, { url: properties.URL_EXPEDIENTE + solicitudActual.numeroExpediente + '/' + infoUsuario.interesadoNif, method: 'get'}).then(response => {
                
                idFaseIdEstado = {
                    idFase : response.data.idFase,
                    idEstado : response.data.idEstado,
                }
                dispatch(insertNewState({filnedName: 'faseEstadoExpediente', value: idFaseIdEstado}));

                if(solicitudActual.edicion || solicitudActual.subsanar || solicitudActual.alegar || solicitudActual.revisarPresentacion || solicitudActual.corregirSolicitud
                        || solicitudActual.revisarSubsanacion || solicitudActual.corregirSubsanacion || solicitudActual.revisarAlegacion || solicitudActual.corregirAlegacion
                        || solicitudActual.modBaja || solicitudActual.renovRada){
                   idExpediente = response.data.id;
                   dispatch(insertNewState({filnedName: 'idExpediente', value: idExpediente}));
                }
            });

            let datosRecuperar;
            
            if(solicitudActual.edicion || solicitudActual.subsanar || solicitudActual.alegar || solicitudActual.revisarPresentacion || solicitudActual.corregirSolicitud
                || solicitudActual.revisarSubsanacion || solicitudActual.corregirSubsanacion || solicitudActual.revisarAlegacion || solicitudActual.corregirAlegacion
                || solicitudActual.modBaja || solicitudActual.renovRada){
                datosRecuperar = {
                    idConvocatoria : convocatoriaSeleccionada.id,
                    idExpediente: idExpediente,
                    idFase: idFaseIdEstado.idFase,
                    rutaFormulario: resourceFormNuevaSolicitud,
                    perfilSeleccionado: perfilSeleccionado.descripcion,
                    solicitudColaborativa: isConvocatoriaColaborativa
                }
                dispatch(updatePropertyOfState({ fieldName: 'solicitudActual', propertyName: 'id', propertyValue: idExpediente }));
            }else {
                datosRecuperar = {
                    idConvocatoria : convocatoriaSeleccionada.id,
                    idExpediente : solicitudActual.id,
                    idFase : idFaseIdEstado.idFase
                }
            }
            
            // Obtenemos la información relativa al BOJA del procedimiento actual
            await crudOperation(crudOperationsType.CUSTOM, 'procedimiento', { url: "/" + procedimientoActual.id, method: 'get'}).then(response => {

                const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
                const fechaOrdenDecretoLey = new Date(response.data.fechaOrdenDecretoLey)

                infoBoja.identificadorOrdenDecretoLey = response.data.identificadorOrdenDecretoLey
                infoBoja.diaOrdenDecretoLey = fechaOrdenDecretoLey.getDate()
                infoBoja.mesOrdenDecretoLey = meses[fechaOrdenDecretoLey.getMonth()]
                infoBoja.anyoOrdenDecretoLey = fechaOrdenDecretoLey.getFullYear()
                infoBoja.numeroBoja = response.data.numeroBoja
                infoBoja.fechaBoja = response.data.fechaBoja
                infoBoja.anyoConvocatoriaEjercicio = response.data.convocatoria
            })

            let numExpediente = solicitudActual.numeroExpediente;

            // Recuperamos la información del expediente y le agregamos la obtenida anteriormente del BOJA
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_FORMULARIO_EXPEDIENTE, { url: properties.URL_OBTENER_CAMPO_FORMULARIO, method: 'post', data: datosRecuperar }).then(response => {

                response.data = {...response.data, informacionBoja: infoBoja, numExpediente};
                setSubmissionData(response);
                props.handleLoading(false);
                respuesta = response;
            })
            

            
        } else {
            let input = {
                dataSource: calcularDataSource(codigoAplicacion),
                idSolicitudesPDF: idSol,
                idProcedimientos: idPro,
            }
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_BACK, { url: properties.URL_GET_DATA, method: 'post', data: input }).then(response => {
                // Se realiza una búsqueda de fechas, para realizar el formateo de estas en caso necesario
                if (Object.keys(response.data).length !== 0) {
                    let valoresTratados = buscarFecha(response.data, formatosFecha.entrada);
                    response.data = valoresTratados;
                }
                setSubmissionData(response);
                props.handleLoading(false);
                respuesta = response;
            })
        }
        return respuesta;
    }
    /**
     * @function handleSubmit
     * @param {*} data Recibe los datos del formulario
     * @param {*} tipoGuardado Recibe el tipo de guardado realizado (guardado del paso actual o guardado del formulario al completo)
     * @param {*} mostrarMensaje Recibe un booleano
     */
    const handleSubmit = async (data, tipoGuardado, mostrarMensaje) => {
        
            props.handleLoading(true);

            if(procedimientoActual.fromPct3){

                let datoExpediente = {
                    id: solicitudActual.id,
                }

                let input = {
                    datoExpediente: datoExpediente,
                    idConvocatoria: convocatoriaSeleccionada.id,
                    idFase: faseEstadoExpediente.idFase,
                    formulario: JSON.stringify(data.data),
                    rutaFormulario: resourceFormNuevaSolicitud,
                    nifFirmante: infoUsuario.interesadoNif,
                }

                await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_FORMULARIO_EXPEDIENTE, { url: properties.URL_GUARDAR_FORMULARIO_PCT, method: 'post', data: input })
                    .then(response => {
                        props.handleError(null);
                        //Indica si se muestra el mensaje al realizar el guardado y además inserta un mensaje u otro, dependiendo del botón de guardado que ha sido pulsado
                        mostrarMensaje &&
                            props.handleSetMessage(tipoGuardado === btnsGuardar.guardarForm ? msg.msg.formulario.exitoFormulario : msg.msg.pasoActual.exitoPasoActual, msg.severity.exito);
                        props.handleLoading(false);
                        //Se establece a true en caso de que se pulse el botón del guardado del formulario al completo
                        setFormularioCorrecto(tipoGuardado === btnsGuardar.guardarForm ? true : false);
                    }).catch(function (error) {
                        props.handleLoading(false)
                        props.handleError(error.input.datos);
                        props.handleSetMessage(tipoGuardado === btnsGuardar.guardarForm ? msg.msg.formulario.errorFormulario : msg.msg.pasoActual.errorPasoActual, msg.severity.error);
                        props.handleProcessing(false);
                        setAvanzarPagina(false);
                });
            } else {
                let idPro = procedimientoActual.id;
                let idSol = solicitudActual.idMoaddSolicitudPdf;

                let input = {
                    dataSource: calcularDataSource(codigoAplicacion),
                    idSolicitudesPDF: idSol,
                    idProcedimientos: idPro,
                    datos: buscarFecha(data.data, formatosFecha.salida) // Se realiza una búsqueda de fechas, para realizar el formateo de estas en caso necesario
                }
                await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_BACK, { url: properties.URL_SAVE_DATA, method: 'post', data: input }).then(response => {
                    props.handleError(null);
                    //Inserta un mensaje u otro, dependiendo del botón de guardado que ha sido pulsado
                    props.handleSetMessage(tipoGuardado === btnsGuardar.guardarForm ? msg.msg.formulario.exitoFormulario : msg.msg.pasoActual.exitoPasoActual, msg.severity.exito);
                    props.handleLoading(false);
                    //Se establece a true en caso de que se pulse el botón del guardado del formulario al completo
                    setFormularioCorrecto(tipoGuardado === btnsGuardar.guardarForm ? true : false);
                }).catch(function (error) {
                    props.handleLoading(false)
                    props.handleError(error.input.datos);
                    props.handleSetMessage(tipoGuardado === btnsGuardar.guardarForm ? msg.msg.formulario.errorFormulario : msg.msg.pasoActual.errorPasoActual, msg.severity.error);
                    props.handleProcessing(false);
                    setAvanzarPagina(false);
                });
            }
               
    }

    const handleChange = (value) => {
        value.isValid = false;
        if (value.changed != undefined) {
            if (value.changed.component.key == "telefono") {
                pruebaValidationFunction();
            }
            /* Casuística específica para el formulario 0021569ictconectividadpoligonos, realiza el borrado
            de una serie de campos cuando en la primera página se ha seleccionado en el radio button la opción interesado */
            if ((resourceFormNuevaSolicitud === '0021569ictconectividadpoligonos' || resourceFormNuevaSolicitud === '0022142IctRedDeEmpresas' )
                && value.changed.component.key === "actuaEnCalidadDe"
                && value.data.datos.actuaEnCalidadDe === 'representanteDeEntidadUOtraPersona') {
                    document.querySelector("#nombreRazonSocialDenominacion").defaultValue ='';
                    document.querySelector("#dNINIENIF").defaultValue='';
                    document.querySelector("#primerApellido").defaultValue='';
                    document.querySelector("#segundoApellido").defaultValue = '';
                    document.querySelector("#nombreRazonSocialDenominacion").value ='';
                    document.querySelector("#dNINIENIF").value='';
                    document.querySelector("#primerApellido").value='';
                    document.querySelector("#segundoApellido").value = '';
            }
        }
    }

    const handleSubmitFomr = async (data) => {
        //Paso 1. Se oculta el scroll vertical para evitar que se desplace el formulario durante la generacion del pdf
        document.querySelector('body').style.overflow = 'hidden';
        //Paso 2. Se establece el scroll vertical a 200px 
        window.scroll(0, 200);
        //Paso 3. Se realiza el guardado del formulario
        await handleSubmit(data, btnsGuardar.guardarForm, true);
    }

    const handleCustomEvents = (customEvent) => {
        //Evento para guardar el formulario con los valores que se encuentren insertados en ese preciso momento
        if (customEvent.type === btnsGuardar.guardarPaso) {
            handleSubmit(customEvent, btnsGuardar.guardarPaso, true);
        }
        if(customEvent.type === btnsCancelar.cancelarPaso){
            history.push("/BandejaSolicitudes");
        }
    }

    const pruebaValidationFunction = (value) => {
        console.log("ENTRA!")
        return true;
    }

    /**
     * @function obtenerPasosFormulario Función que obtiene todos los pasos del formulario (elementos del DOM)
     * @returns pasosForm Devuelve un array con los pasos del formulario
     */
    const obtenerPasosFormulario = () => {
        let pasos = document.querySelectorAll('ul.pagination > li.page-item > span.page-link');
        let pasosObtenidos = [];
        let nombrePaso = null;

        for (const paso of pasos) {
            /*nombrePaso = paso['innerText'].replace(/\s+/g, '').toLowerCase();
            paso.setAttribute('id',`${nombrePaso}`);*/
            pasosObtenidos.push(paso);
        }
        return pasosObtenidos;
    }

    /**
     * @function obtenerFormularioPdf Método que obtiene el formulario PDF una vez se ha rellenado la solicitud
     */
    const obtenerFormularioPdf = async () => {
        try {
            let procedenciaConvocatoria = obtenerProcedenciaConvocatoria();
            let formularioPdf = (procedenciaConvocatoria === 'PCT2') ? formularioPdfPCT2() : formularioPdfPCT3();
            props.handleProcessing(formularioPdf.formAgenerar === 'pdfConVolcadoHTML' ? true : false);
            await generarPDF(formularioPdf.formAgenerar, formularioPdf.solicitud, formularioPdf.dataSource, procedimientoActual.id, formularioPdf.fase, procedenciaConvocatoria);
            
            props.handleSetMessage(msg.msg.pdf.exitoPdf, msg.severity.exito);
            setAvanzarPagina(true);
        } catch (error) {
            setAvanzarPagina(false);
            props.handleSetMessage(msg.msg.pdf.errorPdf, msg.severity.error);
        }
    }

    /**
     * @function formularioPdfPCT3 Método que obtiene los valores necesarios para la generación de PDF
     * @returns Devuelve un objeto con todos los valores necesarios
     */
    const formularioPdfPCT3 = () => {
        let formularioPdf = {
            solicitud: solicitudActual.numeroExpediente,
            fase: fase,
            formAgenerar: pdfAgenerar
        }

        return {...formularioPdf};
    }
    
    /**
     * @function formularioPdfPCT2 Método que obtiene los valores necesarios para la generación de PDF
     * @returns Devuelve un objeto con todos los valores necesarios
     */
    const formularioPdfPCT2 = () => {
        let formularioPdf = {
            solicitud: solicitudActual.idMoaddSolicitudPdf,
            dataSource: calcularDataSource(codigoAplicacion),
            fase: fase,
            formAgenerar: pdfAgenerar
        };
        
        return {...formularioPdf};
    }

    /**
     * @function obtenerPdfAgenerar Método que obtiene el tipo de pdf a generar dependiendo de la procencia de la convocatoria
     * si es de PCT2 o de PCT3
     */
    const obtenerPdfAgenerar = async () => {
        let pdf = (obtenerProcedenciaConvocatoria() === 'PCT2') ? await obtenerPdfAgenerarPCT2() : await obtenerPdfAgenerarPCT3();
        setPdfAgenerar(pdf);
    }

    /**
     * @function obtenerPdfAgenerarPCT2 Método que obtiene el tipo de PDF a generar para las convocatoria de PCT2
     * @returns Devuelve un String con el tipo de PDF a generar
     */
    const obtenerPdfAgenerarPCT2 = async () => {
        let res= null;
        let valoresProcedimiento = null;

        let input = {
            idProcedimiento: procedimientoActual.id,
            valoresAbuscar: ["tablaConfiguracionDeFormularios"]
        }

        // Se obtienen los valores del procedimiento
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ADMINISTRADOR, { url: properties.URL_VALORES_FORM, method: 'post', data: input }).then(response => {
            valoresProcedimiento = response.data;
        });

        //Obtención del tipo de formulario a generar a partir de la fase
        for (const valor of valoresProcedimiento['tablaConfiguracionDeFormularios']) {
            if ((valor['fase']).toLowerCase() === fase.toLowerCase()) {
              res = valor['formularioAGenerar'];
              break;
            }
        }
    
        return res;
    }

    /**
     * @function obtenerPdfAgenerarPCT3 Método que obtiene el tipo de PDF a generar para los convocatorias de PCT3
     * @returns Devuelve un String con el tipo de PDF a generar
     */
    const obtenerPdfAgenerarPCT3 = async () => {
        let res = null;
      
        let input = {
            idConvocatoria: convocatoriaSeleccionada.id,
            idFase: idFase,
            idEstado: idEstadoFase
        };

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_FORMULARIO_FASE_CONVOCATORIA, { url: properties.RESOURCE_TIPO_PDF, method: 'post', data: input }).then(response => {
            res = response.data;
        });

        return res;
    }

    /**
     * @function precargaDatos Función que realiza el "seteo" de la precarga de datos en la hook submissionData
     * @param {*} submission Valor recibido del método recuperarFormulario
     * @param {*} form Formulario obtenido
     */
    const precargaDatos = async (submission, form) => {
        let data = {};
        let valoresProcedimiento = null;
        let token = loadState(localStorageName.token, false);
        Object.assign(submission.headers, {'Authorization': `Bearer ${token}`});
        //Paso 1. Se comprueba si se ha obtenido valores del formulario, en caso de recibirlos, no se realizar'a la precarga
        if(Object.keys(submission.data).length === 0) {
            let input = {
                idProcedimiento: procedimientoActual.id,
                valoresAbuscar: ["precargaDesdeDatosEnSesion","precargaEntreDistintosFormularios"]
            }
            //Paso 2. Se realiza llamada al endPoint obtenerValoresProcedimiento
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ADMINISTRADOR, { url: properties.URL_VALORES_FORM, method: 'post', data: input }).then(response => {                
                valoresProcedimiento = response;
            });
            //Paso 3. Obtención e inserción en el objeto data de los valores obtenidos para la precarga de datos de sesión y para la precarga de datos entre formularios
            precargaDatosSesion(valoresProcedimiento.data.precargaDesdeDatosEnSesion, data);
            for (const valor of valoresProcedimiento.data.precargaEntreDistintosFormularios) {
                valor.faseDestino.toUpperCase() === fase.toUpperCase() &&
                    await precargaDatosEntreFormularios(valor, data);
            }
            
            //Paso 4. Obtenicón e inserción en el objeto data de los valores obtenidos para la precarga de datos de la adminsitración de procedimientos
            await precargaDatosAdminProc(form, data);

            //Paso 5: Cargamos atributo 'url'
            await cargaCampoOcultoURL(form, data);

            //Paso 6: Precarga de numero solicitud 
            await cargaNumeroSolicitud(data);

            //Paso 7. "Seteo" del objeto data en la hook submission
            setSubmissionData({data});
        }
      }

    /**
     * Carga en el formulario el campo de urlContexto
     * @param {} form 
     * @param {*} objeto 
     * @returns 
     */  
    const cargaCampoOcultoURL = async (form, objeto) => {

        let urlEndPoint= getUrl();
        let valores = {
            contextoUrl: urlEndPoint,
            idProcedimiento: procedimientoActual.id
        };
        
        Object.keys(valores).length !== 0 && Object.assign(objeto, valores);
        return objeto;
    }

    /**
     * Precarga en formulario el numero de solicitud
     * @param {*} data 
     * @returns 
     */  
    const cargaNumeroSolicitud = async (data) => {
        data.identificacionDeLaActividadProyectoComportamientoOSituacionParaLaQueSeSolicitoLaSubvencion = idExpTrewa;
        return data;
    }

    /**
     * @function precargaDatosAdminProc Función que obtiene los valores a precargar de la administración de procedimientos
     * @param {*} form Formulario obtenido
     * @param {*} objeto Objeto al que se añadirán los valores obtenidos
     */
    const precargaDatosAdminProc = async (form, objeto) => {
        let destinatarioExpedientes = null, informacionBoja = null;

        //Paso 1. Se obtienen los valores de la administración de procedimientos a insertar
        destinatarioExpedientes = await obtenerDestinatariosExpedientes(procedimientoActual.id, form);
        informacionBoja = await obtenerInformacionBoja(procedimientoActual.id, form);       
        
        /* Paso 2. Se insertan los valores en el objeto que realizará el setSubmission. Previamente se evalúa si se han
        obtenido valores a precargar. Si no se han obtenido, no se añadirá al objeto */
        Object.keys(destinatarioExpedientes).length !== 0 && Object.assign(objeto, destinatarioExpedientes);
        Object.keys(informacionBoja).length !== 0 && Object.assign(objeto, informacionBoja);
    }
    
    /**
     * Precargar datos configurados en el mod ad al formulario desde el contexto
     * @param {*} configuracionDatosSesion 
     */
    const precargaDatosSesion = async (configuracionDatosSesion, objeto) => {
       let datos;
        configuracionDatosSesion && configuracionDatosSesion.forEach(element => {
            if(element.fase.toUpperCase() === fase.toUpperCase()){
                let indexPrimerPunto = element.nombreVariableSesion.indexOf('_');

                if(indexPrimerPunto === -1){
                    datos = loadState(element.nombreVariableSesion, true);

                }else{
                    let localSt = element.nombreVariableSesion.substring(0, indexPrimerPunto);
                    let tmp = loadState(localSt, true);
                    /* Se evita que se produzca un fallo en caso de que se inserte de forma incorrecta el nombre de la variable de sesión
                    insertada en el modulo de administración */
                    if (tmp != undefined) {
                        let listNombreVariables = element.nombreVariableSesion.split('_');
                        listNombreVariables.shift();

                        listNombreVariables.forEach(nombreVariable => {
                            datos = tmp[nombreVariable];
                            tmp = datos;
                        });
                        montarObjetoSubmission(datos, element.nombreCampoApi, objeto);
                    }
                }
            }
        });
    }

    /**
     * Precargar datos configurados en el mod ad al formulario desde otro formulario
     * @param {*} configuracionEntreFormularios 
     */
    const precargaDatosEntreFormularios = async (configuracionEntreFormularios, objeto) =>{
        let inputGetDataForm = null;
        
        if(idExpTrewa){
            let inputGetSolicitud = {
                        dataSource: calcularDataSource(codigoAplicacion),
                        idExpedienteTrewa: idExpTrewa,
                        nombreFase: configuracionEntreFormularios.faseOrigen.toUpperCase()
                    }
                    await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_SOLICITUD, { url: properties.URL_GET_SOLICITUD_POR_EXP, method: 'post', data: inputGetSolicitud }).then(response => {
                        inputGetDataForm = {
                            dataSource: calcularDataSource(codigoAplicacion),
                            idSolicitudesPDF: response.data.idSolicitud,
                            idProcedimientos: procedimientoActual.id,
                        }
                    });
                    await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_BACK, { url: properties.URL_GET_DATA, method: 'post', data: inputGetDataForm }).then(res => {
                        let datosPrecarga = res.data;
                        let  listNombresCamposApi = configuracionEntreFormularios.nombreCampoApiOrigen.split('_');
                        
                        if (datosPrecarga) {
                            if (datosPrecarga[listNombresCamposApi[0]] !== undefined && Array.isArray(datosPrecarga[listNombresCamposApi[0]])) {
                                montarObjetoSubmissionDataGrid(datosPrecarga, listNombresCamposApi, objeto);
                            } else {
                                montarObjetoSubmission(datosPrecarga, configuracionEntreFormularios.nombreCampoApiDestino, objeto);
                               /* listNombresCamposApi && listNombresCamposApi.forEach(nombreCampoApi => {
                                    if (datosPrecarga[nombreCampoApi] !== undefined) {
                                        datosPrecarga = datosPrecarga[nombreCampoApi];
                                        montarObjetoSubmission(datosPrecarga, configuracionEntreFormularios.nombreCampoApiDestino, objeto);
                                    }
                                });*/
                            }
                        }
                    });
                }
    }

    /**
     * @function montarObjetoSubmissionDataGrid Función que inserta en el objeto el valor de las tablas dinámicas
     * @param {*} datos Datos recibidos del formulario
     * @param {*} listNombresCamposApi Nombre de los campos de la api
     * @param {*} objeto Objeto al que se asignará el valor obtenido
     */
    const montarObjetoSubmissionDataGrid = (datos, listNombresCamposApi, objeto) => {     
        let nombreTabla = listNombresCamposApi[0];   
        let posicion = listNombresCamposApi[1];
        let nombreCampo = listNombresCamposApi[2];

        /**
         * La función trabaja con el objeto datos que contiene todos los valores del formulario.
         * Elimina todos los valores recibidos a excepción de los valores a precargar de la tabla dinámica.
         * Finalmente lo que se asigna al objeto es el objeto datos con los datos de la tabla dinámica que se desean
         * precargar.
         */

        // Paso 1. Se eliminan todos los valores que no sean la tabla buscada
        for (const apiName in datos) {
            apiName !== nombreTabla &&
                delete datos[apiName];
        }

        // Paso 2. Se extrae el valor de la tabla dinámica que se añadirá al objeto
        if (Object.keys(datos[nombreTabla][posicion]).length > 1) {
            for (const valor in datos[nombreTabla][posicion]) {
                valor.toString() !== nombreCampo &&
                    delete datos[nombreTabla][posicion][valor];  
            }            
        }
        // Paso 3. En caso de que la tabla dinámica contenga más de 1 posición, se procede a borrar todas menos la indicada
        if (datos[nombreTabla].length > 1) {
            for (let i = 0; i < datos[nombreTabla].length; i++) {
                i !== parseInt(posicion) &&
                    datos[nombreTabla].splice(i);
            }
        }
        // Paso 4. Se verifica si ya existe la tabla con valores, si es así se inserta el valor y no se sobreescribe
        if (Object.keys(objeto).length !== 0) {
            for (const key of Object.keys(objeto)) {
                if (key.toString() === nombreTabla) {
                    Object.assign(datos[nombreTabla][posicion], objeto[nombreTabla][posicion]);
                    break;
                }
            }
        }
        // Paso 5. Se inserta el valor obtenido
        Object.assign(objeto, {...datos});
    }

    /**
     * Montar objeto submission para la precarga de datos en el formulario
     * @param {*} datos 
     * @param {*} nombreCampoApi 
     */
    const montarObjetoSubmission = (datos, nombreCampoApi, objeto) => {
        if(datos){
        let listaCamposApi = nombreCampoApi.split('_');
        let submissionDatos = {};
        let container = null;

            if(listaCamposApi.length===1){
                submissionDatos = {};
                submissionDatos[listaCamposApi[0]] = datos;

                if (objeto[container]) {
                    Object.assign(objeto[container], submissionDatos[container]);
                } else {
                    Object.assign(objeto, submissionDatos);
                }

            }else { 
                /*Se hace el for para buscar el valor que despues 
                posteriorimente se meterá en el Object creado mas abajo*/
                let tmp = datos;
                let valida = false;
                for(let i=0; i<=listaCamposApi.length - 1; i++){
                    let variable = listaCamposApi[i];
                    if(tmp[variable]){
                        valida = true;
                        submissionDatos[variable] = tmp[variable];
                        tmp = tmp[variable];          
                    }else{
                        valida = false;
                    }
                
                }
                /*Realizamos una transformacion del campo que hemos convertido en 
                lista a un Objeto que se ira anidando segun los campos que vengan
                y lo añadiimo al objeto que devolvemos en el anterior metodo */
                if(valida){
                    let length = 0; 
                    listaCamposApi.reduce(function(o, s) {
                        length++;
                        if(length >= listaCamposApi.length){
                            return o[s] = tmp;
                        } else if (o[s]) { 
                            return o[s] = o[s]; 
                        }else{
                            return o[s] = {};
                        }
                    }, objeto);
                }
                

                /*submissionDatos = {};
                submissionDatos[listaCamposApi.pop()] = datos;                 
                for(let i=(listaCamposApi.length-1); i>=0; i--){

                    let tmp = {};
                    container = listaCamposApi[i];
                    tmp[listaCamposApi[i]] = submissionDatos;
                    submissionDatos = tmp;
                }
                //Inserción de los valores obtenidos en el objeto.

                //Se evalúa si el container ya existe, en caso de que exista, se insertará el valor en dicho container
                if (objeto[container]) {
                    Object.assign(objeto[container], submissionDatos[container]);
                } else {
                    Object.assign(objeto, submissionDatos);
                }*/
            }
        }
    };

    /**
     * @function buscarFecha Función que recibe un objeto (formulario form.io) y comprueba si dentro de este existen fechas,
     * en el caso de que existan, realizará un formateo de la fecha según el tipo de formato recibido
     * y devolverá el objeto con la fecha formateada.
     * @param {*} valores Objeto form.io recibido
     * @param {*} tipoFormato Tipo de formato para las fechas
     * @return Objeto con las fechas formateadas
     */
    const buscarFecha = (valores, tipoFormato) => {
        // Primera dimensión, raíz objeto
        for (const campoDimension1 in valores) {
            if (typeof valores[campoDimension1] === 'object') {
                let valoresDimension1 = valores[campoDimension1];

                // Segunda dimensión, página (menú paso a paso)
                for (const campoDimension2 in valoresDimension1) {
                    if (Array.isArray(valoresDimension1[campoDimension2])) {
                        let valoresDimension2 = valoresDimension1[campoDimension2];

                        // Tercera dimensión, tabla dataGrid (Array)
                        for (const campoDimension3 in valoresDimension2) {

                            // Cuarta dimensión, objeto del array
                            for (const campoDimension4 in valoresDimension2[campoDimension3]) {
                                isFecha(valoresDimension2[campoDimension3][campoDimension4], tipoFormato) &&
                                    (valoresDimension2[campoDimension3][campoDimension4] 
                                        = formatearFecha(valoresDimension2[campoDimension3][campoDimension4], tipoFormato));
                            }
                        }
                    } else {
                        isFecha(valoresDimension1[campoDimension2], tipoFormato) &&
                            (valoresDimension1[campoDimension2] = formatearFecha(valoresDimension1[campoDimension2], tipoFormato));
                    }
                }      
            } else {
                isFecha(valores[campoDimension1], tipoFormato) && 
                    (valores[campoDimension1] = formatearFecha(valores[campoDimension1], tipoFormato));
            }
        }
        return valores;
    }

    /**
     * @function isFecha Función que comprueba si el campo recibido es de tipo fecha, se utiliza una expresión u otra dependiendo 
     * del tipo de formato recibido.
     * @param {*} campo Valor del campo recibido
     * @param {*} tipoFormato Tipo de formato de la fecha recibida
     * @returns Valor booleano que indica si el valor recibido (campo) cumple con la expresión regular
     */
    const isFecha = (campo, tipoFormato) => {
        let regexSalida = /^\d{4}-(0[\d]|1[0-2])-(0[\d]|[12][\d]|3[01])[T](0[\d]|1[\d]):(0[\d]|1[\d]):(0[\d]|1[\d])\+\d{2}:\d{2}/;        
        let regexEntrada = /^([0-2][0-9]|3[0-1])(\/|-)(0[1-9]|1[0-2])\2(\d{4})$/;
        let regex = (tipoFormato === formatosFecha.salida) ? regexSalida : regexEntrada;
        
       return regex.test(campo);
    }

    /**
     * @function formatearFecha Función que realiza el formateo de la fecha según el tipo de formato ("salida" o "entrada")
     * El formato salida es el formato de fecha que se insertará en BD (dd-MM-yyyy) y el formato entrada el que se devolverá
     * al formulario cuando se realice la precarga de este (formato timestamp 2022-07-16T00:00:00+02:00).
     * @param {*} fecha 
     * @param {*} tipoFormato 
     * @returns fecha formateada
     */
    const formatearFecha = (fecha, tipoFormato) => {
        let fechaObtenida = null
        // Formato de salida (Inserción en BD), formato recibido 2022-07-16T00:00:00+02:00, formateado a 16-07-2022
        if (tipoFormato === formatosFecha.salida) {
            let f = new Date(fecha);
            let dia = f.getDate() < 10 ? '0'+f.getDate() : f.getDate();
            let mes = (f.getMonth()+1) < 10 ? '0'+(f.getMonth()+1) : (f.getMonth()+1);
            let anyo = f.getFullYear();
            fechaObtenida =  dia + '-' + mes + '-' + anyo;
        } else {
            /* Formato de entrada (Recuperación de BD e inserción en formulario (precarga)), formato recibido 16-07-2022,
             * formateado a 2022-07-16T00:00:00+02:00 */
            let anyo = fecha.substring(fecha.length - 4, fecha.length);
            let dia = fecha.substring(0, 2);
            let mes = fecha.substring(3, 5);
            fechaObtenida = anyo + '-' + mes + '-' + dia + 'T00:00:00+02:00';
        }
        return fechaObtenida;
    }

    /**
     * @function ocultarComponentesNoSubsanables Función que esconde los componentes marcados como no subsanables en la ventana de convocatoria de
     * la PCT, de manera que el ciudadano no podrá editarlos al subsanar.
     * 
     * @param componente componente de formio
     * @param arrayKeyNoSubsanables array de keys de los campos no subsanables
     */
    const ocultarComponentesNoSubsanables = (componente, arrayKeyNoSubsanables) => {
        if (componente?.key && arrayKeyNoSubsanables.includes(componente?.key)) {
            componente.disabled =false;
        }
        var componentes = componente?.components;
        if (componentes && componentes.length > 0) {
            for (let i = 0; i < componentes.length; i++) {
                ocultarComponentesNoSubsanables(componentes[i], arrayKeyNoSubsanables);
            }
        } else {
            return false;
        }
    };

    /**
     * @function scrollUp Función que establece arriba el scroll de la página, se utiliza para los eventos producidos cuando se
     * pulsan los botones siguiente (onNextPage), atrás (onPrevPage) o cuando no se ha informado un campo obligatorio (onError).
     */
    const scrollUp = () => {
        window.scroll(0,200);
    }

    /**
     * @function handleOnNextPage Función que se ejecuta cuando se realiza un cambio de página, pulsando el botón
     * siguiente (onNextPage).
     * @param {*} data Recibe los valores del formulario
     */
    const handleOnNextPage = async (data) => {
        // Paso 1. Guardado del estado actual del formulario
        await handleSubmit(data.submission, btnsGuardar.guardarPaso, false);

        // Paso 2. Se desplaza el scroll en la cabecera de la página
        scrollUp();
    }

    return (
        <div>
            {/*A la etiqueta options hay que pasarle los parametros directamente, 
            NO creamos una constante. En caso de hacerlo se producirá un BUG y se harán multiples 
            llamadas al onSubmit y al onChange*/}
            <Form
                form={formData}
                onCustomEvent={handleCustomEvents}
                onSubmit={handleSubmitFomr}
                onChange={handleChange}
                onNextPage={handleOnNextPage}
                onPrevPage={scrollUp}
                options={{
                    ov: true,
                    language: 'sp',
                    evalContext: {
                        // Funciones específicas para validación de datos
                        validarNIF: functionValidacionID,
                        validarCampo: functionValidadorRegex,
                        validarIBAN: functionValidacionIBAN,
						camposEspecificos: functionCamposEspecificos,
                        // Funciones específicas para carga de selectores genéricos
                        getProvincias: getProvincias,
                        getProvinciasDescripcion: getProvinciasDescripcion,
                        getMunicipios: getMunicipios,
                        getTipoVias: getTipoVias,
                        getPaises: getPaises,
                        getOrganismos: getOrganismos,
                        //Funciones específicas para formulario ICT-Conectividad Polígonos
                        getValorICT: getValorICT,
                        //Funciones de precarga para el bloque de componentes personales
                        calculaActuaEnCalidadDe: calculaActuaEnCalidadDe,
                        obtenerValoresUsuario: obtenerValoresUsuario,
                        obtenerConvocatoria: obtenerConvocatoria,
                        //Funcion que permite generar un popup parametrizado desde el formulario
                        showPopup: showPopup,
                        // Funciones específicas para formulario Predoctorales2023_Presentacion_SICA
                        getDatosRepresentanteSica: getDatosRepresentanteSica,
                        obtenerPerfilSeleccionado: obtenerPerfilSeleccionado,
                        obtenerOrganismo: obtenerOrganismo,
                        //Funcion específica para formularios RADA
                        obtenerModBajaRADA: obtenerModBajaRADA,
                        // Funciones específicas para formulario ComplementosAutonomicos
                        getSolicitantesPuntosHistorico : getSolicitantesPuntosHistorico
                       },

                    i18n: {
                        sp: {
                            complete: 'Formulario cumplimentado correctamente',
                            error: 'Hubo un problema',
                            next: 'Siguiente',
                            previous: 'Atrás',
                            cancel: 'Cancelar',
                            submit: 'FINALIZAR Y ADJUNTAR DOCUMENTACIÓN',
                            required: 'Es obligatorio rellenar este campo',
                            confirmCancel: '¿Estás seguro que quieres cancelar?',
                            submitError: 'Por favor revise el formulario y corrija todos los errores.',
                            mask: '',
                            searchPlaceholderValue: 'Buscar'
                        }
                }}}
                submission={submissionData} />
            <Confirmacion
                accionConfirmacion={ () => { setMostrarConfirmacion(false) }}
                titulo={popUpTitle}
                mostrar={mostrarConfirmacion}
                mensaje={popUpMesagge}
                botonera='confirSoloAceptar'
                quitarImg={false}
                tamMarginTop='10'
                isPopUpPdf={false}
                textBotonConfirmarPersonalizado={false}
                isImagenPersonalizada={true}
                centrarContenido={true}
                imagen={`${getContextFromUrl()}` + popUpImage}
                isTextoEnriquecido={true}
            />
        </div>

    );
}

export default FormNuevaSolicitud;